import { Component, Input } from '@angular/core';

import { FiltersComponent } from '../../common/filters.component';

@Component({
	selector: 'app-vehicles-documents-filters',
	templateUrl: './vehicles-documents-filters.component.html',
	styleUrls: ['./vehicles-documents-filters.component.css'],
})
export class VehiclesDocumentsFiltersComponent extends FiltersComponent {
	@Input() vehicleDocumentsTypes: Array<any>;
	@Input() statuses: Array<any>;
	@Input() types: Array<any>;
	filters = {
		documentTypeId: null,
		statuses: null,
		types: null,
	};
	protected filtersAfterLoad() {
		this.filters.statuses = ['1', '5'];
		this.filters.documentTypeId = ['registrationcard', 'authtouse', 'license'];
	}
	filtersDefault() {
		this.filtersClear();
		this.filters.statuses = ['1', '5'];
		this.filters.documentTypeId = ['registrationcard', 'authtouse', 'license'];
	}
}
